var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDropdown',_vm._b({directives:[{name:"tooltip",rawName:"v-tooltip",value:('Compartilhar'),expression:"'Compartilhar'"}],attrs:{"items":_vm.items},on:{"select":_vm.share}},'AppDropdown',_vm.dropdownSettings_,false))
}
var staticRenderFns = []

export { render, staticRenderFns }